import { getDataDictionaryViewReferences } from '@api';

import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const getCoreDataDictionaryViewReferencesAsyncSlice = createGetAsyncSlice({
	name: 'CoreDataDictionaryViewReferences',
	receive: true,
	request: true,
	requestHandler: getDataDictionaryViewReferences,
	yieldType: SagaYieldType.Latest
});
